export const monitoring = {
    logError: (error, data) => {
        console.error(error, data);
        if (typeof window !== "undefined" && window.DD_RUM) {
            window.DD_RUM.onReady(function () {
                const normalizedError = error instanceof Error ? error : new Error(String(error));
                window.DD_RUM?.addError(normalizedError, {
                    data,
                    has_xsso_id: String(!!window.xsso?.id?.()),
                    xsso_state: String(window.xsso?.state?.()),
                });
            });
        }
    },
};
//# sourceMappingURL=monitoring.js.map